(ns rlws.iot-cloud.frontend.authentication
  (:require [ajax.core :as ajax]
            [re-frame.core :as rf]
            [rlws.iot-cloud.frontend.ajax-common :as ajax-common]
            [rlws.iot-cloud.frontend.config :as config]
            [tick.core :as tick]))

(defn is-authenticated?
  [db]
  (let [{:keys [token expires-at]} (get-in db [:authentication])]
    (and token (tick/< (tick/now) (tick/parse expires-at)))))

(rf/reg-event-fx
 ::store-token
 [(rf/inject-cofx :store)]
 (fn [{:keys [db store]} [_ {:keys [access_token expires_in] :as payload}]]
   (let [expires-at (str (tick/+
                          (tick/now)
                          (tick/new-duration expires_in :seconds)))
         authn (-> payload
                   (dissoc :access_token :expires_in)
                   (merge {:token access_token
                           :expires-at expires-at}))]
     {:db (assoc db :authentication authn)
      :store (assoc store :authentication authn)})))

(rf/reg-event-fx
 ::refresh-token
 (fn [{:keys [db]} [_ {:keys [access_token expires_in] :as payload}]]
   {:http-xhrio
    {:uri (str config/site-api-origin "/_site/token")
     :method :post
     ::type ::bearer
     ::in [:authentication]
     :format (ajax.core/url-request-format)
     :response-format ajax-common/detect-response-format
     :on-success [::store-token]
     :on-failure [:generic-failure]}}))

(defn authentication-type
  [_ http-xhrio]
  (::type http-xhrio))

(defmulti add-authentication #'authentication-type)

(defmethod add-authentication ::bearer
  [db {::keys [in token] :as http-xhrio}]
  (let [token (or token (:token (get-in db in)))
        expires-at (:expires-at (get-in db in))]
    (cond
      (nil? token)
      (do
        (js/console.error "Token not found")
        nil)

      (tick/< (tick/parse expires-at) (tick/now))
      (do (js/console.error "Token expired")
          nil)

      :else
      (-> http-xhrio
          (dissoc :authentication)
          (assoc-in [:headers "Authorization"] (str "Bearer " token))))))

(defmethod add-authentication ::basic
  [db {::keys [username password] :as http-xhrio}]
  (when (and username password)
    (let [basic-auth (str "Basic " (js/btoa (str username ":" password)))]
      (-> http-xhrio
          (dissoc :authentication)
          (assoc-in [:headers "Authorization"] basic-auth)))))

(def http-interceptor
  (rf/->interceptor
   :id ::http
   :after (fn [{{:keys [db event original-event]} :coeffects {:keys [http-xhrio]} :effects :as context}]
            (if (get-in context [:effects :http-xhrio ::type])
              (if-let [authed-xhrio (add-authentication db (get-in context [:effects :http-xhrio]))]
                (assoc-in context [:effects :http-xhrio] authed-xhrio)
                (assoc context :effects {:dispatch [:navigate :login]}))
              context))))

(rf/reg-event-fx
 ::intercept-unauthorized
 (fn [{:keys [db]} [_ continuation response]]
   {:fx [[:dispatch
          (if (= 401 (:status response))
            [:logout]
            continuation)]]}))
